import React from 'react'
import { Menu } from 'semantic-ui-react'

export const ORG_REVIEW_TAB = 'org-review'
export const MERGE_TAB = 'merge-organizations'

const OrganizationsTabs = ({ activeTab, onTabChange }) => {
    return (
        <Menu pointing secondary>
            <Menu.Item
                name={ORG_REVIEW_TAB}
                active={activeTab === ORG_REVIEW_TAB}
                onClick={() => onTabChange(ORG_REVIEW_TAB)}
            >
                Review Organizations
            </Menu.Item>
            <Menu.Item
                name={MERGE_TAB}
                active={activeTab === MERGE_TAB}
                onClick={() => onTabChange(MERGE_TAB)}
            >
                Merge Organizations
            </Menu.Item>
        </Menu>
    )
}

export default OrganizationsTabs
